/* global jQuery */
import {MiniBar} from 'minibarjs';
import eventBus from "../utils/eventBus";

const scrollbarCons = document.querySelectorAll('[data-callback-dates] .wpcf7-form-control-wrap,[data-callback-timeslots] .wpcf7-form-control-wrap');

if(scrollbarCons) {

  scrollbarCons.forEach(elm => {

    let scrollbar;
    scrollbar = new MiniBar(elm, {
      minBarSize: 50,

      hideBars: false,
      alwaysShowBars: true,
      horizontalMouseScroll: false,
      scrollX: true,
      scrollY: false,
      navButtons: true,
      scrollAmount: 50,
      onInit: function(e,f) {
        let btns = document.querySelectorAll('.mb-button');
        if(btns) {
          btns.forEach(btn => {
            btn.setAttribute('type', 'button');
          })
        }
      }

    });

  });
}

